<!-- Phone mockup -->
<div class="phone-frame">

  <!-- Notch -->
  <div class="phone-notch">
    <div class="phone-camera"></div>
  </div>

  <!-- Status bar -->
  <div class="phone-statusbar">
    <span>14:03</span>
    <div class="flex-row-icons">
      <mat-icon class="status-icon">signal_cellular_alt</mat-icon>
      <mat-icon class="status-icon">wifi</mat-icon>
      <mat-icon class="status-icon">battery_std</mat-icon>
    </div>
  </div>

  <!-- App header -->
  <div class="phone-header">
    <mat-icon class="phone-nav-icon">arrow_back</mat-icon>
    <span class="phone-title">{{ title }}</span>
    <mat-icon class="phone-nav-icon">check</mat-icon>
  </div>

  <!-- Scrollable form content -->
  <div class="phone-content">

    <!-- Info bar (green) -->
    <div class="phone-info-bar">
      <mat-icon class="info-bar-icon">info_outline</mat-icon>
      <span>{{ infoBarText || title }}</span>
    </div>

    <!-- ── Fields ─────────────────────────────────────────────────────────── -->
    <ng-container *ngFor="let field of fields">

      <div *ngIf="field.type === FieldType.Divider" class="phone-divider"></div>

      <div *ngIf="field.type === FieldType.PhotoPicker" class="phone-field">
        <div class="phone-field-label">{{ field.label }}</div>
        <div class="phone-photo-btn">
          <mat-icon>add</mat-icon>
        </div>
      </div>

      <div *ngIf="field.type === FieldType.Checkbox" class="phone-field phone-field-row">
        <mat-icon class="phone-checkbox-icon">check_box_outline_blank</mat-icon>
        <span class="phone-field-text">{{ field.label }}</span>
      </div>

      <div *ngIf="field.type === FieldType.Select" class="phone-field">
        <div class="phone-field-label-sm">{{ field.label }}</div>
        <div class="phone-select-row">
          <span class="phone-field-placeholder">{{ field.hint || field.label }}</span>
          <mat-icon class="phone-dropdown-arrow">arrow_drop_down</mat-icon>
        </div>
        <div class="phone-underline"></div>
      </div>

      <div *ngIf="field.type !== FieldType.PhotoPicker
               && field.type !== FieldType.Checkbox
               && field.type !== FieldType.Select
               && field.type !== FieldType.Divider"
           class="phone-field">
        <div class="phone-field-label-sm">{{ field.label }}</div>
        <div *ngIf="field.type === FieldType.Date" class="phone-field-value">{{ today | date:'dd.MM.yyyy' }}</div>
        <div *ngIf="field.type === FieldType.Time" class="phone-field-value">{{ today | date:'HH:mm' }}</div>
        <div *ngIf="field.type !== FieldType.Date && field.type !== FieldType.Time"
             class="phone-field-placeholder">{{ field.hint || '' }}</div>
        <div class="phone-underline"></div>
      </div>

    </ng-container>

    <!-- ── Child levels ───────────────────────────────────────────────────── -->
    <div *ngFor="let child of children"
         class="phone-level-item"
         [class.phone-level-item-selected]="isSelected(child)"
         (click)="selectChild(child)">
      <mat-icon class="phone-level-icon">folder_open</mat-icon>
      <div class="phone-level-info">
        <div class="phone-level-name">{{ child.name }}</div>
        <div class="phone-level-sub">
          {{ child.description || (child.fields?.length ? (child.fields!.length + ' Felder') : '') }}
        </div>
      </div>
      <mat-icon class="phone-level-arrow">chevron_right</mat-icon>
    </div>

    <!-- Empty state -->
    <div *ngIf="!fields.length && !children.length" class="phone-empty">
      <mat-icon>inbox</mat-icon>
      <span>Keine Felder definiert</span>
    </div>

    <!-- Save button -->
    <div class="phone-save-btn">Speichern</div>

  </div><!-- /phone-content -->

  <!-- Home bar -->
  <div class="phone-home-bar"></div>

</div><!-- /phone-frame -->
